module.exports = function() {

  /**
   *  Validates a value is null.
   *
   *  @param cb The callback function.
   */
  this.main.null = function validate(cb) {
    if(this.validates()) {
      this.required();
      this.type();
    }
    cb();
  }

}



//////////////////
// WEBPACK FOOTER
// ../node_modules/async-validate/plugin/null.js
// module id = 1376
// module chunks = 93